var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-message d-flex flex-row align-items-center"},[_c('i',{staticClass:"icon-error mr-1"}),_c('p',{staticClass:"error-msg m-0"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }